import { render, staticRenderFns } from "./Invoices-Payment.vue?vue&type=template&id=56733057&"
import script from "./Invoices-Payment.vue?vue&type=script&lang=js&"
export * from "./Invoices-Payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports